import { Component } from '@angular/core';

@Component({
    selector: 'ah-placeholder',
    template: `<div class="puzzle-image"><img src="/assets/images/puzzles.png"></div>`,
    styles: [`
        .puzzle-image {
            padding-top: 50px;
            width: 100%;
            text-align: center;
        }
        .puzzle-image img {
            width: 100%;
            max-width: 800px;
        }
    `],
    standalone: false
})
export class PlaceholderComponent {
    constructor() { }
}
